import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function MechanismSection() {
  return <section className="py-12 md:py-14 px-6 bg-navy text-white relative overflow-hidden" data-id="element-82">
      <div className="absolute top-0 right-0 w-48 h-48 bg-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-83"></div>
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-sage/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-84"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-85">
        <FadeIn data-id="element-86">
          <span className="text-gold font-semibold tracking-wider text-xs uppercase mb-2 block" data-id="element-87">
            El Mecanismo Único
          </span>
          <h2 className="font-serif text-2xl md:text-3xl mb-5" data-id="element-88">
            El Ciclo de Encendido Somático (Protocolo CES)
          </h2>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-89">
          <div className="space-y-3 text-base md:text-lg text-white/80 leading-relaxed" data-id="element-90">
            <p data-id="element-91">
              En lugar de forzar tu mente, hablamos directamente a tu sistema
              nervioso. A través de micropasos de "Inercia Cero" y declaraciones
              bíblicas de identidad, reactivamos los cables entre tu cerebro y
              tus músculos.
            </p>
            <p data-id="element-92">
              Es un encendido suave que respeta tu dolor mientras te devuelve la
              movilidad. No necesitas energía para empezar; el método genera el
              primer impulso por ti.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}